import PropTypes from "prop-types"
import React from "react"

const SelectionChip = ({ avatar, children, onRemove, ariaLabel }) => (
  <div
    className="mt-1 inline-flex max-w-full items-center gap-2 rounded-full border border-gray-300 bg-white py-1 pl-1 pr-2 text-sm"
    role="status"
    aria-label={ariaLabel}
  >
    {avatar}
    {children}
    {onRemove && (
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remove ${ariaLabel?.toLowerCase() ?? "selection"}`}
        className="ml-1 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-transparent p-0 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
      >
        <i className="icon icon-close-mdc text-xs leading-none" />
      </button>
    )}
  </div>
)

SelectionChip.propTypes = {
  avatar: PropTypes.node,
  children: PropTypes.node.isRequired,
  onRemove: PropTypes.func,
  ariaLabel: PropTypes.string,
}

export default SelectionChip
